import { render } from "./ConstructorSettings.vue?vue&type=template&id=343418fa&scoped=true"
import script from "./ConstructorSettings.vue?vue&type=script&lang=js"
export * from "./ConstructorSettings.vue?vue&type=script&lang=js"

import "./ConstructorSettings.vue?vue&type=style&index=0&id=343418fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343418fa"]])

export default __exports__